import { useCreditsResponseEvent } from "../events/useCreditsResponseEvent";
import { handleAjaxError } from "../actions/handleAjaxError";
import { loadModal } from "../actions/loadModal";
import {
    contentGeneratorModalSelector,
    contentGeneratorReason,
    bindContentGeneratorModal,
    openContentGeneratorModal
} from "./contentGeneratorModal";

export function creditsModal() {
    bindContentGeneratorModal();

    const useCreditsTriggerSelector = '[data-bs-target="#growtypeChatUseCreditsModal"], [data-target="#growtypeChatUseCreditsModal"]';
    const useCreditsCaptureFlag = 'growtypeChatUseCreditsCaptureBound';
    let lastUseCreditsTrigger = null;

    function bindUseCreditsModalShowEvent($modal) {
        $modal
            .off('show.bs.modal.growtypeChatUseCreditsModal')
            .on('show.bs.modal.growtypeChatUseCreditsModal', function (event) {
                const trigger = event.relatedTarget ||
                    $(this).data('last-trigger-element') ||
                    document.activeElement?.closest?.(useCreditsTriggerSelector);
                const shouldOpen = applyUseCreditsModalContent(trigger);
                if (shouldOpen === false) {
                    event.preventDefault();
                }
            });
    }

    function normalizeUseCreditsParams(paramsDecoded = {}) {
        const normalizedParams = { ...paramsDecoded };

        if (!normalizedParams.credits_amount) {
            if (normalizedParams.unlock_credits) {
                normalizedParams.credits_amount = normalizedParams.unlock_credits;
            } else if (normalizedParams.credits) {
                normalizedParams.credits_amount = normalizedParams.credits;
            }
        }

        return normalizedParams;
    }

    function applyUseCreditsModalContent(triggerElement) {
        const growtypeChatUseCreditsModal = $('#growtypeChatUseCreditsModal');

        if (!growtypeChatUseCreditsModal.length) {
            return true;
        }

        // If triggerElement is missing or is the modal itself, try to find the last known trigger
        if (!triggerElement || $(triggerElement).is('#growtypeChatUseCreditsModal')) {
            const modalId = growtypeChatUseCreditsModal.attr('id');
            const possibleTrigger = growtypeChatUseCreditsModal.data('last-trigger-element') ||
                document.activeElement?.closest?.(useCreditsTriggerSelector) ||
                (modalId ? $(`[data-bs-target="#${modalId}"], [data-target="#${modalId}"]`).first()[0] : null);

            triggerElement = possibleTrigger;
        }

        if (!triggerElement || $(triggerElement).is('#growtypeChatUseCreditsModal')) {
            // If we still don't have a trigger, don't do anything to the modal content
            return true;
        }

        const trigger = $(triggerElement);

        // Robust parameter reading
        let rawParams = trigger.attr('data-params');
        let paramsDecoded = null;

        if (rawParams) {
            try {
                paramsDecoded = JSON.parse(rawParams);
            } catch (e) {
                paramsDecoded = trigger.data('params');
            }
        }

        if (!paramsDecoded || typeof paramsDecoded !== 'object') {
            paramsDecoded = {};
        }

        paramsDecoded = normalizeUseCreditsParams(paramsDecoded);
        const initialTriggerName = trigger.attr('data-initial-trigger-name');
        const paramsString = JSON.stringify(paramsDecoded);

        // Store active state
        growtypeChatUseCreditsModal
            .attr('data-params', paramsString)
            .attr('data-initial-trigger-name', initialTriggerName);

        // Apply content
        const growtypeChatUseCreditsModalInitialTitle = growtypeChatUseCreditsModal.find('.modal-title').attr('data-title') || '';
        const growtypeChatUseCreditsModalInitialBody = growtypeChatUseCreditsModal.find('.modal-body').attr('data-body') || '';

        // Reset to initial content first
        growtypeChatUseCreditsModal.find('.modal-title').html(growtypeChatUseCreditsModalInitialTitle);
        growtypeChatUseCreditsModal.find('.modal-body').html(growtypeChatUseCreditsModalInitialBody);

        if (paramsDecoded.reason === contentGeneratorReason) {
            openContentGeneratorModal(paramsDecoded, trigger, initialTriggerName);
            closeFancyboxIfOpen();
            return false;
        }

        if (paramsDecoded.modal_title) {
            growtypeChatUseCreditsModal.find('.modal-title').html(paramsDecoded.modal_title);
        }

        if (paramsDecoded.modal_body) {
            growtypeChatUseCreditsModal.find('.modal-body').html(paramsDecoded.modal_body);
        }

        if (paramsDecoded.credits_amount) {
            const $creditsSpan = growtypeChatUseCreditsModal.find('.modal-body .e-credits');
            if ($creditsSpan.length) {
                $creditsSpan.text(paramsDecoded.credits_amount);
            }
        }

        closeFancyboxIfOpen();

        return true;
    }

    // If modal is already in DOM (server-rendered fallback), bind show event immediately.
    const $existingModal = $('#growtypeChatUseCreditsModal');
    if ($existingModal.length) {
        bindUseCreditsModalShowEvent($existingModal);
    }

    $(document)
        .off('click.growtypeChatUseCreditsModalOpen', useCreditsTriggerSelector)
        .on('click.growtypeChatUseCreditsModalOpen', useCreditsTriggerSelector, function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            const triggerEl = this;
            let $modal = $('#growtypeChatUseCreditsModal');

            function openModal($m) {
                $m.data('last-trigger-element', triggerEl);
                const shouldOpen = applyUseCreditsModalContent(triggerEl);
                if (shouldOpen === false) return false;

                window.growtypeModal?.show($m[0]);
            }

            if ($modal.length) {
                openModal($modal);
            } else {
                loadModal(
                    growtype_chat_ajax.get_use_credits_modal_action,
                    null,
                    { modalId: 'growtypeChatUseCreditsModal' }
                ).then(function ($m) {
                    bindUseCreditsModalShowEvent($m);
                    openModal($m);
                }).catch(function (err) {
                    console.error(err);
                });
            }

            return false;
        });

    if (!window[useCreditsCaptureFlag]) {
        window[useCreditsCaptureFlag] = true;

        document.addEventListener('click', function (event) {
            // In Safari, click target can sometimes be a text node (nodeType 3)
            const actualTarget = event.target.nodeType === 3 ? event.target.parentNode : event.target;
            const triggerElement = actualTarget?.closest?.(useCreditsTriggerSelector);

            if (!triggerElement) {
                return;
            }

            const $modal = $('#growtypeChatUseCreditsModal');
            if ($modal.length) {
                $modal.data('last-trigger-element', triggerElement);
            }
        }, true);
    }

    function closeFancyboxIfOpen() {
        const instance = $.fancybox.getInstance(); // Get the active Fancybox instance

        if (instance) {
            $.fancybox.close();
        }
    }

    /**
     *
     */
    $(document)
        .off('click.growtypeChatUseCreditsContinue', '.btn-growtype-chat-use-credits')
        .on('click.growtypeChatUseCreditsContinue', '.btn-growtype-chat-use-credits', function (event) {
            event.preventDefault();

            let btn = $(this);
            let params = $(this).attr('data-params') ?? $(this).parent().attr('data-params') ?? $(this).closest('.modal').attr('data-params');
            let ctaLabel = $(this).text();

            btn.attr('disabled', true);

            try {
                params = params ? JSON.parse(params) : {};
            } catch (e) {
                console.error("Invalid JSON in data-params:", params);
                params = {}; // Reset to an empty object if JSON parsing fails
            }

            if (params['cta_label']) {
                btn.text(params['cta_label']);
            }

            btn.append('<span class="spinner-border spinner-border-sm ms-2"></span>');

            $(this).closest('.modal').find('textarea, input').each(function () {
                let name = $(this).attr('name');  // Get input name
                let value = $(this).val();        // Get input value

                if (name) {  // Ensure input has a name before storing
                    params[name] = value;
                }
            });

            let initialTriggerName = $(this).closest('.modal').attr('data-initial-trigger-name');

            $.ajax({
                url: growtype_chat_ajax.url,
                type: "post",
                data: {
                    action: 'growtype_chat_use_credits',
                    params: params,
                }, success: function (response) {
                    btn.attr('disabled', false);
                    btn.text(ctaLabel);

                    /**
                     * Events
                     */
                    document.dispatchEvent(useCreditsResponseEvent({
                        response: response,
                        params: params,
                    }));

                    if (response.success) {
                        if (response.data.initial_trigger_text) {
                            $('button[data-bs-target="#growtypeChatUseCreditsModal"][data-initial-trigger-name="' + initialTriggerName + '"]').text(response.data.initial_trigger_text);
                        }

                        if (response.data.redirect_url) {
                            window.location.href = response.data.redirect_url;
                        }

                        if (response.data.reload) {
                            window.location.reload();
                        }

                        window.growtypeModal?.hide('growtypeChatUseCreditsModal');
                    } else {
                        handleAjaxError(response);
                    }
                }, error: function (response) {
                    btn.attr('disabled', false);
                    btn.text(ctaLabel);

                    /**
                     * Events
                     */
                    document.dispatchEvent(useCreditsResponseEvent({
                        response: response,
                        params: params,
                    }));

                    handleAjaxError(response);
                }, complete: function () {
                },
            })
        });
}
